import clsx from 'clsx'
import React, { ReactElement, ReactNode } from 'react'
import FormInputWrapper from '../FormInputWrapper'
import useStyles from './RadioGroup.styles'

interface Props {
  label?: string
  isVertical?: boolean
  flex?: boolean
  children: ReactNode
}

const RadioGroup = ({ label, isVertical = false, children, flex = false }: Props): ReactElement => {
  const classes = useStyles()

  return (
    <div>
      {label && <div className={classes.label}>{label}</div>}
      <FormInputWrapper>
        <div className={clsx(classes.radioWrapper, { [classes.vertical]: isVertical, [classes.flex]: flex })}>
          {children}
        </div>
      </FormInputWrapper>
    </div>
  )
}

export default RadioGroup
